
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/monitor",
      function () {
        return require("private-next-pages/docs/monitor/index.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/monitor"])
      });
    }
  